/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { Modal } from 'react-bootstrap';
import SelfAssessmentActions from 'edrolo/actions/SelfAssessmentActions';
import SelfRating from '../SelfRating';
import s from './styles.scss';
import { Icon, Pill, enums } from 'edrolo-ui';
import { NAV_DESTINATION } from '../../constants';

class SelfRateModal extends Component {
  state = {
    showModal: false,
    next: null,
  };

  close = () => {
    this.setState({
      showModal: false,
    });
  };

  setNext = (next) => {
    this.setState({
      next,
    });
  };

  handleClick = (next) => {
    this.props.hasSuccessMeasure ? this.props.onSave(next) : this.open(next);
  };

  handleRatingClick = (rating) => {
    SelfAssessmentActions.save(this.props.lesson.get('id'), rating).then(
      this.handleRatingCompleted
    );
  };

  handleRatingCompleted = () => {
    this.close();
    setTimeout(this.props.onSave(this.state.next), 300);
  };

  open = (next) => {
    this.setState({
      showModal: true,
      next,
    });
  };

  render() {
    return (
      <div className={s.selfRateModal}>
        <div className={s.nextButtons}>
          {this.props.hasQuestionSet && (
            <button
              onClick={() => this.handleClick(NAV_DESTINATION.QUESTION_SET)}
              disabled={this.props.disabled}
            >
              <Pill
                variant={enums.PillVariant.CIRCLE}
                color={enums.ColorHue.GREEN}
              >
                <Icon name={enums.Icons.QUESTION} />
              </Pill>
              <span>Practice questions</span>
              <Icon name={enums.Icons.CHEVRON_RIGHT} />
            </button>
          )}
          <button
            onClick={() => this.handleClick(NAV_DESTINATION.NEXT_LESSON)}
            disabled={this.props.disabled}
          >
            <Pill
              variant={enums.PillVariant.CIRCLE}
              color={enums.ColorHue.BLUE}
            >
              <Icon name={enums.Icons.LESSON} />
            </Pill>
            <span>Next lesson</span>
            <Icon name={enums.Icons.CHEVRON_RIGHT} />
          </button>
        </div>

        <Modal
          container={this.props.container}
          show={this.state.showModal}
          onHide={this.close}
          data-test="self-rate-modal"
        >
          <div className={s.modalContent}>
            <h2>Rate your understanding of this lesson</h2>
            <SelfRating onClick={this.handleRatingClick} />
            {this.props.lesson.get('key_knowledge_text') ? (
              <p>
                <b>Key Knowledge:</b>{' '}
                {this.props.lesson.get('key_knowledge_text')}
              </p>
            ) : null}
            <p>
              <b>What&rsquo;s this all about?</b>
              <br />
              This rating goes on your study planner which helps you know which
              lessons you have mastered or need to review.
            </p>
          </div>
        </Modal>
      </div>
    );
  }
}

export default SelfRateModal;
